import { Button, Checkbox, Grid, Icon, Table } from 'semantic-ui-react'
import React, { useState }  from 'react'
import Section from '../UI/Section'
import { NavLink } from 'react-router-dom'
import ObjectivesIndicator from '../elements/ObjectivesIndicator'
import ConversationsModal from './ConversationsModal'
import { withoutDeleted } from './agentListHelpers'

const AngentTable = ({
	agents = [],
	title = '',
	options = {},
	toggleCheckboxFilter,
	toggleAgentActiveState,
	detachAll,
	forcefullyLogoutAgent,
	deleteAgent,
	onConversationRemoved
}) => {
  const [conversationsModal, setConversationsModal] = useState(null)
  const openConversationsPopup = async(agent) => {
    setConversationsModal({ agent })
  }

	return (
		<Section>
			<Grid columns={2}>
				<Grid.Column>
					<h2>{title}</h2>
				</Grid.Column>
				<Grid.Column className="right aligned">
					<Checkbox
						label="Show inactive agents"
						name="includeDeactivated"
						onChange={toggleCheckboxFilter}
						checked={options.includeDeactivated}
          />
				</Grid.Column>
			</Grid>
			<Table celled striped>
				<Table.Header>
					<Table.Row>
						<Table.HeaderCell>Name</Table.HeaderCell>
						<Table.HeaderCell>Live</Table.HeaderCell>
						<Table.HeaderCell>Email</Table.HeaderCell>
						<Table.HeaderCell>Agent goals</Table.HeaderCell>
						<Table.HeaderCell># Conversations</Table.HeaderCell>
						<Table.HeaderCell>Activate</Table.HeaderCell>
						<Table.HeaderCell>Actions</Table.HeaderCell>
					</Table.Row>
				</Table.Header>
				<Table.Body>
					{withoutDeleted(agents).filter((ag) => ag.type === 'agent')
						.map((agent, i) => {
							return (
								<Table.Row key={i}>
									<Table.Cell>{agent.name}</Table.Cell>
									<Table.Cell><div className={`active-state bg-${agent.status}`}></div></Table.Cell>
									<Table.Cell>{agent.email}</Table.Cell>
									<Table.Cell>
										<ObjectivesIndicator
											agentObjectives={agent.objectives.map((o) => o.id)}
										/>
									</Table.Cell>
									<Table.Cell onClick={() => openConversationsPopup(agent)}>
										{agent.conversationCount > 0 ? <a href="#">{agent.conversationCount}</a> : agent.conversationCount}
									</Table.Cell>
									<Table.Cell><Checkbox toggle checked={agent.isActive} onClick={() => toggleAgentActiveState(agent.id, !agent.isActive)}/></Table.Cell>
									<Table.Cell className='table-actions'>
										<NavLink style={{color: "#008AD5"}} to={`/admin/agents/edit/${agent.id}?retUrl=${location.pathname + location.search}`}><Icon name="pencil square" size='big'/></NavLink>
										{!!agent.conversationCount && <button title="Detach all conversations" onClick={() => detachAll(agent.id)}>
											<i className="big icons">
												<Icon className="blue" name="comment" size="small"/>
												<Icon className="red" name="ban" size="small"/>
											</i>
										</button>}
										{ agent.status !== 'offline' && <button title="Forcefully logout the agent" onClick={() => forcefullyLogoutAgent(agent.id)}>
											<i className="big icons">
												<Icon className="blue" name="sign out" size="small"/>
											</i>
										</button>}
										<Button icon compact color="red" onClick={() => deleteAgent(agent.id)}><Icon name="delete"/></Button>
									</Table.Cell>
								</Table.Row>
							)
						})
					}
				</Table.Body>
			</Table>
			{ conversationsModal && <ConversationsModal agent={conversationsModal.agent} onClose={() => setConversationsModal(null)} onConversationRemoved={onConversationRemoved}/>}
		</Section>
	)
}

export default AngentTable
